export const listingsUrl = id => `/buildings/${id}/listings.json`;
